// frontend/src/app/project-corpus/domain/openalex-types.ts
//
// Curated OpenAlex work-type and source-type taxonomy used across the
// import wizard, paper row chips, filter bar, and edit dialog.

export interface TypeOption {
  readonly value: string;
  readonly label: string;
}

export const WORK_TYPE_COMMON: readonly TypeOption[] = [
  { value: 'article', label: 'Article' },
  { value: 'review', label: 'Review' },
  { value: 'preprint', label: 'Preprint' },
  { value: 'book-chapter', label: 'Book Chapter' },
  { value: 'book', label: 'Book' },
  { value: 'dataset', label: 'Dataset' },
  { value: 'dissertation', label: 'Dissertation' },
  { value: 'report', label: 'Report' },
  { value: 'letter', label: 'Letter' },
  { value: 'editorial', label: 'Editorial' },
  { value: 'other', label: 'Other' },
];

const WORK_TYPE_EXTRA: readonly TypeOption[] = [
  { value: 'erratum', label: 'Erratum' },
  { value: 'grant', label: 'Grant' },
  { value: 'peer-review', label: 'Peer Review' },
  { value: 'reference-entry', label: 'Reference Entry' },
  { value: 'standard', label: 'Standard' },
  { value: 'retraction', label: 'Retraction' },
  { value: 'supplementary-materials', label: 'Supplementary Materials' },
  { value: 'paratext', label: 'Paratext' },
  { value: 'libguides', label: 'LibGuides' },
];

export const WORK_TYPE_ALL: readonly TypeOption[] = [...WORK_TYPE_COMMON, ...WORK_TYPE_EXTRA];

export const SOURCE_TYPE_COMMON: readonly TypeOption[] = [
  { value: 'journal', label: 'Journal' },
  { value: 'conference', label: 'Conference' },
  { value: 'repository', label: 'Repository' },
  { value: 'book-series', label: 'Book Series' },
];

const SOURCE_TYPE_EXTRA: readonly TypeOption[] = [
  { value: 'ebook-platform', label: 'E-Book Platform' },
  { value: 'metadata', label: 'Metadata' },
  { value: 'other', label: 'Other' },
];

export const SOURCE_TYPE_ALL: readonly TypeOption[] = [...SOURCE_TYPE_COMMON, ...SOURCE_TYPE_EXTRA];

const WORK_TYPE_MAP = new Map<string, string>(WORK_TYPE_ALL.map((t) => [t.value, t.label]));
const SOURCE_TYPE_MAP = new Map<string, string>(SOURCE_TYPE_ALL.map((t) => [t.value, t.label]));

/** Returns the human-readable label for a work type value, falling back to the raw value. */
export function labelForWorkType(value: string): string {
  return WORK_TYPE_MAP.get(value) ?? value;
}

/** Returns the human-readable label for a source type value, falling back to the raw value. */
export function labelForSourceType(value: string): string {
  return SOURCE_TYPE_MAP.get(value) ?? value;
}
